import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BookOpen, Lightbulb, CaretDown } from "@phosphor-icons/react";
import { PageContainer, EmptyState } from "@/components/customer/PageContainer";
import { MarkdownLite } from "@/components/common/MarkdownLite";
import { api } from "@/lib/api";

export default function SystemGuides() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/knowledge").then(({ data }) => setEntries(data)).catch(() => setEntries([])).finally(() => setLoading(false));
  }, []);

  return (
    <PageContainer
      overline="Tips & Guides"
      title="System Guides"
      subtitle="Approved On The Move technical guides and know-how to help you understand and maintain your caravan."
    >
      {loading ? (
        <div className="text-neutral-600">Loading...</div>
      ) : entries.length === 0 ? (
        <EmptyState icon={Lightbulb} title="No guides published yet" hint="Approved customer-facing knowledge entries will appear here." />
      ) : (
        <div className="space-y-3 max-w-3xl">
          {entries.map((e, i) => {
            const isOpen = open === e.id;
            return (
              <motion.div
                key={e.id}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.03 }}
                className="bg-[#141414] border border-neutral-800 rounded-xl overflow-hidden"
                data-testid="guide-card"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : e.id)}
                  className="w-full flex items-center gap-4 p-5 text-left hover:bg-white/[0.02] transition-colors"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#73bf44]/10 flex items-center justify-center shrink-0">
                    <BookOpen size={20} className="text-[#73bf44]" weight="duotone" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-heading font-semibold text-white">{e.title}</div>
                    {e.category && <div className="text-xs text-neutral-500">{e.category}</div>}
                  </div>
                  <CaretDown size={18} className={`text-neutral-500 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pt-0 border-t border-neutral-800/60">
                    <div className="pt-4 text-neutral-300">
                      <MarkdownLite text={e.technical_information} />
                    </div>
                    {(e.applies_to || []).length > 0 && (
                      <div className="flex flex-wrap gap-1.5 mt-4">
                        {e.applies_to.map((m) => (
                          <span key={m} className="text-[0.65rem] px-2 py-0.5 rounded-full bg-black/40 border border-neutral-700 text-neutral-400">
                            {m}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      )}
    </PageContainer>
  );
}
